import script from "./SyncSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncSpinner.vue?vue&type=script&setup=true&lang=js"

import "./SyncSpinner.vue?vue&type=style&index=0&id=e2a034d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2a034d2"]])

export default __exports__